import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface UserLocation {
  city: string
  region?: string
  country: string
  lat?: number
  lon?: number
}

interface LocationState {
  location: UserLocation | null
  setLocation: (location: UserLocation) => void
  clearLocation: () => void
}

export const useLocationStore = create<LocationState>()(
  persist(
    (set) => ({
      location: null,
      setLocation: (location) => set({ location }),
      clearLocation: () => set({ location: null }),
    }),
    { name: 'user-location' },
  ),
)
